export default "__VITE_ASSET__Df0$XEvX__"